import { AuthenticatedApiClient } from '@guiker/listing-inquiry-shared'
import { useAuthenticatedApiClient } from '@guiker/react-framework'

export const useAuthenticatedListingInquiryApiClient = useAuthenticatedApiClient(AuthenticatedApiClient)
